import { Box, SxProps, Theme } from "@mui/material"
import { useIsMobile } from "@recall/common"
import { SurfaceBox } from "components/shared/surfaces/SurfaceBox"

export const FormWrapper: React.FC<React.PropsWithChildren<any>> = ({ children }) => {
    const isMobile = useIsMobile()

    if (isMobile) {
        return (
            <Box sx={styles.content} px={3}>
                {children}
            </Box>
        )
    }

    return (
        <SurfaceBox sx={styles.wrapper}>
            <Box sx={styles.content}>{children}</Box>
        </SurfaceBox>
    )
}

const styles: Record<string, SxProps<Theme>> = {
    wrapper: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 2,
        p: 4,
        width: 450,
        borderRadius: 2,
    },
    content: {
        textAlign: "center",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
    },
}
